function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 8,
    viewBox: "0 0 76.744 76.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M60.379 73.109 37.871 50.6 15.364 73.109A9 9 0 0 1 2.634 60.38l22.508-22.508L2.634 15.364a9 9 0 0 1 12.73-12.728l22.507 22.508L60.379 2.636a9 9 0 0 1 12.728 12.728L50.6 37.872 73.107 60.38a9 9 0 0 1-12.728 12.729Z",
    transform: "translate(.501 .5)",
    style: {
      stroke: "'transparent'",
      strokemiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveLinkIcon);
export default __webpack_public_path__ + "static/media/removeLinkIcon.1379365d27b43b156338c42a2f5076e6.svg";
export { ForwardRef as ReactComponent };